import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../modal';

lessRequire('modules/shared/confirm/dialog.less');

const propTypes = {
	title: PropTypes.string,
	body: PropTypes.string,
	buttonSuccessText: PropTypes.string,
	buttonCancelText: PropTypes.string,
	resolve: PropTypes.func,
	reject: PropTypes.func
};

const defaultProps = {
	buttonSuccessText: 'Подтвердить',
	buttonCancelText: 'Отмена'
};

class Dialog extends  React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="dialog-confirm">
				<Modal
					className="dialog-confirm__wrapper modal-overlay__content"
					isOpen={true}
					title={this.props.title}
					onClose={this.props.reject}
					body={this.renderBody()} />
			</div>
		);
	}

	renderBody() {
		return (
			<div className="dialog-confirm__wrapper-body">
				<div
					className="dialog-confirm__wrapper-body-text"
					dangerouslySetInnerHTML={{__html:this.props.body}} />
				<div className="dialog-confirm__wrapper-body-btn">
					<button
						onClick={this.props.resolve}
						className="button yellow-btn font-proxima-nova-semibold">
						{ this.props.buttonSuccessText }
					</button>
					<button
						onClick={this.props.reject}
						className="button cancel-btn font-proxima-nova-semibold">
						{ this.props.buttonCancelText }
					</button>
				</div>
			</div>
		);
	}
}

Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;

export default Dialog;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/confirm/dialog.js